const getters = {
  masterVehiclesList: state => state.masterVehiclesList,
  masterTransportersList: state => state.masterTransportersList,
  isOrderProcessing: state => state.isOrderProcessing,

  sourceHasEmpty: state => state.sourceHasEmpty,
  sourceList: state => state.sourceList,

  dropsHasEmpty: state => state.dropsHasEmpty,
  dropsList: state => state.dropsList,

  isLoading: state => state.isLoading,
  isLoadingSoldTo: state => state.isLoadingSoldTo,
  list: state => state.list,
  listSoldTo: state => state.listSoldTo,
  filter: state => state.filter,
  filterSoldTo: state => state.filterSoldTo,
  hasEmpty: state => state.hasEmpty,
  hasEmptySoldTo: state => state.hasEmptySoldTo,
  indentBootstrap: state => state.indentBootstrap,
  purchaseOrderFields: state => state.indentBootstrap &&
    state.indentBootstrap.po_indent_config && state.indentBootstrap.po_indent_config.config_field,
  purchaseOrderConfig: state => state.indentBootstrap &&
    state.indentBootstrap.po_indent_config &&
    state.indentBootstrap.po_indent_config.map_purchase_order_to_indent,
  materialCustomFields: state => state.indentBootstrap &&
   state.indentBootstrap.material_custom_fields,
  baseFreightAttachmentMandatory: state => state.indentBootstrap &&
    state.indentBootstrap.freight_attachment,
  truckDetainedConfig: state => state.indentBootstrap &&
    state.indentBootstrap.truck_detained_config,
  isLrMandatoryForMarkAsDelivered: state => state.indentBootstrap &&
    state.indentBootstrap.is_lr_mandatory_for_mark_as_delivered,
  indentCustomFields: state => state.indentBootstrap &&
    state.indentBootstrap.indent_custom_fields,
  indentSourceCustomFields: state => state.indentBootstrap &&
    state.indentBootstrap.indent_source_custom_fields,
  indentDestinationCustomFields: state => state.indentBootstrap &&
    state.indentBootstrap.indent_destination_custom_fields,
};

export default getters;
